"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.valueKindFor = exports.validateGroupDrafts = exports.toSegmentRules = exports.toGroupDrafts = exports.newGroupDraft = exports.newConditionDraft = void 0;
var draftKeySequence = 0;
var nextDraftKey = function () { return "draft_".concat(++draftKeySequence); };
var valueKindFor = function (operator, fieldType) {
    if (!operator || operator === "exists" || operator === "not_exists")
        return "none";
    if (operator === "between")
        return "pair";
    if (operator === "in_last_days" || operator === "not_in_last_days")
        return "days";
    return fieldType !== null && fieldType !== void 0 ? fieldType : "number";
};
exports.valueKindFor = valueKindFor;
var newConditionDraft = function () { return ({ key: nextDraftKey(), field: "", operator: undefined, value: "", value_to: "" }); };
exports.newConditionDraft = newConditionDraft;
var newGroupDraft = function () { return ({ key: nextDraftKey(), conditions: [newConditionDraft()] }); };
exports.newGroupDraft = newGroupDraft;
var valueToText = function (value, fieldType) {
    if (value === undefined || value === null || Array.isArray(value))
        return "";
    var text = String(value);
    return fieldType === "date" ? text.slice(0, 10) : text;
};
var toConditionDraft = function (condition, fieldsByKey) {
    var _a;
    var fieldType = (_a = fieldsByKey.get(condition.field)) === null || _a === void 0 ? void 0 : _a.type;
    var _b = Array.isArray(condition.value) ? condition.value : [undefined, undefined], lower = _b[0], upper = _b[1];
    return {
        key: nextDraftKey(),
        field: condition.field,
        operator: condition.operator,
        value: Array.isArray(condition.value) ? valueToText(lower, fieldType) : valueToText(condition.value, fieldType),
        value_to: Array.isArray(condition.value) ? valueToText(upper, fieldType) : "",
    };
};
var toGroupDrafts = function (rules, fields) {
    var _a;
    var fieldsByKey = new Map(fields.map(function (field) { return [field.key, field]; }));
    return ((_a = rules === null || rules === void 0 ? void 0 : rules.any) !== null && _a !== void 0 ? _a : []).map(function (group) { var _a; return ({ key: nextDraftKey(), conditions: ((_a = group.all) !== null && _a !== void 0 ? _a : []).map(function (condition) { return toConditionDraft(condition, fieldsByKey); }) }); });
};
exports.toGroupDrafts = toGroupDrafts;
var toConditionValue = function (draft, fieldType) {
    switch (valueKindFor(draft.operator, fieldType)) {
        case "none":
            return undefined;
        case "pair":
            return fieldType === "date" ? [draft.value, draft.value_to] : [Number(draft.value), Number(draft.value_to)];
        case "days":
        case "number":
            return Number(draft.value);
        default:
            return draft.value.trim();
    }
};
var toSegmentRules = function (groups, fields) {
    var fieldsByKey = new Map(fields.map(function (field) { return [field.key, field]; }));
    return {
        any: groups.map(function (group) { return ({
            all: group.conditions.map(function (draft) {
                var _a;
                return ({
                    field: draft.field,
                    operator: draft.operator,
                    value: toConditionValue(draft, (_a = fieldsByKey.get(draft.field)) === null || _a === void 0 ? void 0 : _a.type),
                });
            }),
        }); }),
    };
};
exports.toSegmentRules = toSegmentRules;
var isNumeric = function (text) { return text.trim() !== "" && Number.isFinite(Number(text)); };
var conditionError = function (draft, field) {
    if (!draft.field)
        return "Choose a field";
    if (!field)
        return "This field is no longer available";
    if (!draft.operator)
        return "Choose a condition";
    if (!field.operators.includes(draft.operator))
        return "This condition is not available for the field";
    switch (valueKindFor(draft.operator, field.type)) {
        case "none":
            return undefined;
        case "days":
            return /^\d+$/.test(draft.value.trim()) && Number(draft.value) > 0 ? undefined : "Enter a whole number of days";
        case "pair":
            if (!draft.value.trim() || !draft.value_to.trim())
                return "Enter both ends of the range";
            if (field.type === "date")
                return draft.value <= draft.value_to ? undefined : "The start must not be after the end";
            if (!isNumeric(draft.value) || !isNumeric(draft.value_to))
                return "Both ends must be numbers";
            return Number(draft.value) <= Number(draft.value_to) ? undefined : "The lower bound must not exceed the upper bound";
        case "number":
            return isNumeric(draft.value) ? undefined : "Enter a number";
        default:
            return draft.value.trim() ? undefined : "Enter a value";
    }
};
var validateGroupDrafts = function (groups, fields) {
    var fieldsByKey = new Map(fields.map(function (field) { return [field.key, field]; }));
    var errors = {};
    groups.forEach(function (group) {
        if (group.conditions.length === 0)
            errors[group.key] = "Add a condition or remove this group";
        group.conditions.forEach(function (draft) {
            var message = conditionError(draft, fieldsByKey.get(draft.field));
            if (message)
                errors[draft.key] = message;
        });
    });
    return errors;
};
exports.validateGroupDrafts = validateGroupDrafts;
